import type { ReactNode } from 'react';

export function Section({ id, title, children }: { id: string; title: string; children: ReactNode }) {
  return (
    <section id={id}>
      <h2 className="text-xl font-semibold text-text-primary-light dark:text-text-primary-dark mb-4">
        {title}
      </h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export function H3({ children }: { children: ReactNode }) {
  return (
    <h3 className="text-base font-semibold text-text-primary-light dark:text-text-primary-dark mt-5 mb-2">
      {children}
    </h3>
  );
}

export function Callout({ children }: { children: ReactNode }) {
  return (
    <div className="border-l-4 border-primary-500 bg-surface-raised-light dark:bg-surface-raised-dark px-4 py-3 rounded-r-lg text-sm font-medium">
      {children}
    </div>
  );
}

export function Tr({ cells }: { cells: [string, string, string] }) {
  return (
    <tr className="border-b border-border-subtle-light dark:border-border-subtle-dark">
      <td className="py-2 pr-4 font-medium text-text-primary-light dark:text-text-primary-dark">{cells[0]}</td>
      <td className="py-2 pr-4">{cells[1]}</td>
      <td className="py-2">{cells[2]}</td>
    </tr>
  );
}
